import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from '@/App.vue';
import ElementUi from 'element-ui';
import ViewUI from 'view-design';
import ibizLab from 'ibiz-vue-lib';
import axios from "axios";
import { Interceptors, Util } from '@/utils';
import i18n from '@/common/locale'

import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css';
import 'ibiz-vue-lib/lib/ibiz-vue-lib.css';
import '@/styles/default.less';
import '@/utils/dialog'

// 模拟数据
if (process.env.NODE_ENV === 'development') {
  require('@/mock');
}

const pathToRegExp = require('path-to-regexp');
import { AppComponents } from '@/app-register';
import { PageComponents } from './page-register';
import { UserComponent } from '@/user-register';
import { PortletComponent } from '@/portlet-register';
import store from '@/store';
import router from './router';
import Layout from '@pages/wkd/app-index-view/app-index-view.vue'

const win: any = window;
win.axios = axios;

Vue.config.errorHandler = function (err: any, vm: any, info: any) {
  console.log(err);
}

Vue.config.productionTip = false;
Vue.use(ibizLab);
Vue.use(Vuex);
Vue.use(win.AVUE);
Vue.use(VueRouter);;
Vue.use(ElementUi, {
  i18n: (key: any, value: any) => i18n.t(key, value)
});
Vue.use(ViewUI, {
  i18n: (key: any, value: any) => i18n.t(key, value)
});

// Vue.use(utils);
Vue.prototype.$pathToRegExp = pathToRegExp;
Vue.use(AppComponents);
Vue.use(PageComponents);
Vue.use(UserComponent);
Vue.use(PortletComponent);

let getRouter: any = null
router.beforeEach((to: any, from: any, next: any) => {
  // @ts-ignore
  let menuDataByRole=JSON.parse(sessionStorage.getItem('menuDataByRole')) || []
  // @ts-ignore
  let menuDataAll=JSON.parse(sessionStorage.getItem('menuDataAll')) || []

  let path=to.path=='/appindexview/null'?'/appindexview/null':to.path.replace('/appindexview/null','')
  console.log(path)
  if(!path.includes('appindexview') && path!=='/login' && menuDataAll.includes(path) && !menuDataByRole.includes(path)){
    next(from.fullPath)
    alert('您没有此页面访问权限!')
    return
  }

  if(sessionStorage.getItem('lockState') && to.path != '/lock'){
    next({ path: '/lock'});
  }else{
    if (to.meta && !to.meta.ignoreAddPage) {
      router.app.$store.commit('addPage', to);
    }
    // next()
    if (sessionStorage.getItem('token')) {
      if (to.path === '/appindexview' && !getRouter){
        const dynRoute: any = store.getters['dynamicrouter/getRouterItems'];
        let resultRoute: any = Util.loopChildren(dynRoute);
        (router as any).options.routes[0].children = resultRoute
        getRouter = resultRoute
        for (let i = 0, len = resultRoute.length; i < len; i++) {
            // @ts-ignore
            // if(router&&router.addRoute) {
                // @ts-ignore
                router.addRoute('appindexview', resultRoute[i])
            // }
        }
        if (to.redirectedFrom) {
          next({ path: to.redirectedFrom })
        } else {
          next({ ...to, replace: true })
        }
      } else {
        next()
      }
    } else {
      if (['/login', '/sso'].includes(to.path)) {
        next()
      } else {
        next('/login')
      }
    }
  }
});

Interceptors.getInstance(router,store);

const init = async () => {
  new Vue({
      i18n,
      store,
      router,
      render: (h: any) => h(App),
  }).$mount('#app');
};
init();
